import React, { useEffect, useState } from 'react';
import { User } from '../types/User';
import { WizardState } from '../types/WigWizard';
import { saveUserMeasureMents } from '../utils/metafieldService';
import { SpinningCircle } from './SpinningCircle';
import cartState from '../utils/cartGetState'
// @ts-ignore
import * as themeCart from '@shopify/theme-cart';
import { setRedirectAfterLoginOrSignup } from "../utils/localStorage"
import { ProductCustomizerState } from '../types/ProductCustomizer';

export function CameraResult({ user, continueFn, state ,dispatchProductCustomizer, stateProductCustomizer}: { user: User, continueFn: Function, state: WizardState, dispatchProductCustomizer:Function, stateProductCustomizer: ProductCustomizerState}) {
  const [updatedCart, setUpdatedCart] = useState(false)

  // const saveUserMeasurementsLocalStorage = () => {
  //   localStorage.setItem('wizardMeasurements', JSON.stringify(state));
  // };

  useEffect(() => {
    console.log(state.uploadedWithEmail)
    if (state.uploadedWithEmail) saveUserMeasureMents(state, user)
  }, [state.uploadedWithEmail])

  useEffect(() => {
    async function updateCart() {
      const cart = await cartState()
      await Promise.all(cart.items.map(item =>
        themeCart.updateItem(item.key, {
          properties: {
            ...item.properties,
            Lace_Tint_Description: state.laceTintDescription,
            _Cap_Size: state.capSize,
            _Lace_Tint_Hex: state.laceTint,
            _s3_bucket_folder: state.s3BucketFolder,
          }
        }
        )
      ))
      setUpdatedCart(true)
      // setRedirectAfterLoginOrSignup('/checkout')
    }
    if (state.capSize) updateCart()
    // if (state.capSize) saveUserMeasurementsLocalStorage();
  }, [state.capSize])

const handleClick=(e)=>{
    e.preventDefault()
    dispatchProductCustomizer({
        type: "activeStep",
        value: stateProductCustomizer.activeStep+1
      })
      document.getElementById('CameraWizardClose').dispatchEvent(new Event('click'));

}
  return <>
    <div className="w-full flex justify-center text-sm md:text-base leading-none">
      <p className="font-semibold text-center">Our AI has captured your head measurements and lace tint matching to your skin tone</p>
    </div>

    {/* <div className="flex w-full overflow-hidden justify-center items-center h-[60vh]">
      <img className="lazyload mx-auto" data-src={state.frontImage} />
    </div> */}

    {updatedCart
      ?
        <button disabled={!state.capSize}  onClick={handleClick} className="mt-8 text-btn-m md:text-btn-d bg-black text-white uppercase py-4 px-20 w-full md:max-w-[400px] md:block md:mx-auto disabled:opacity-10 disabled:cursor-auto">
          Next
        </button>
      : <div className="mt-8 flex w-full justify-center justify-center items-center">
        <SpinningCircle />
      </div>
    }
  </>
}
